import { Formatters } from "@/hooks/useFormatters";

interface DatePrecision {
  year: boolean;
  month: boolean;
  day: boolean;
  hour: boolean;
  minute: boolean;
  second: boolean;
}

// Cada nivel exige los inferiores en cero: sin encadenar, cualquier tick del día 1 (p. ej. 05:00)
// se clasificaba como inicio de mes y se mostraba «oct» en vez de la hora.
const getDatePrecision = (date: Date): DatePrecision => {
  const minute = date.getSeconds() === 0 && date.getMilliseconds() === 0;
  const hour = minute && date.getMinutes() === 0;
  const day = hour && date.getHours() === 0;
  const month = day && date.getDate() === 1;
  const year = month && date.getMonth() === 0;
  return { second: true, minute, hour, day, month, year };
};

type DateFormatLevel = 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second';

const getFormatLevel = (precision: DatePrecision): DateFormatLevel => {
  if (precision.year) return 'year';
  if (precision.month) return 'month';
  if (precision.day) return 'day';
  if (precision.hour) return 'hour';
  if (precision.minute) return 'minute';
  return 'second';
};

const formatByLevel: Record<DateFormatLevel, (formatters: Formatters, date: Date) => string> = {
  year: (formatters, date) =>
    formatters.formatDateTime(date, { year: 'numeric' }),

  month: (formatters, date) =>
    `{month|${formatters.formatDateTime(date, { month: 'short' })}}`,

  day: (formatters, date) =>
    formatters.formatDateTime(date, { day: 'numeric', month: 'short' }),

  hour: (formatters, date) =>
    formatters.formatDateTime(date, {
      hour: 'numeric',
      minute: 'numeric',
    }),

  minute: (formatters, date) =>
    formatters.formatDateTime((date), {
      hour: 'numeric',
      minute: 'numeric',
    }),


  second: (formatters, date) =>
    formatters.formatDateTime(date, {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }),
};

export const formatXAxisPointer = (
  value: number,
  formatters: Formatters | null
): string => {
  const date = new Date(value);

  if (!formatters) {
    return date.toLocaleString();
  }

  return formatters.formatDateTime(date);
}

export const formatXAxisLabel = (
  value: number | string,
  formatters: Formatters | null
) => {
  const date = new Date(value);
  if (!formatters) {
    return date.toLocaleString();
  }
  const precision = getDatePrecision(date);
  const level = getFormatLevel(precision);
  return formatByLevel[level](formatters, date);
}
